var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isFreeMode)?_c('div',{staticClass:"pro-only-alert-wrapper"},[_c('div',{staticClass:"properties-panel-upgrade-to-pro-notice"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.options.content)}}),_c('a',{staticClass:"properties-panel-upgrade-to-pro-button",attrs:{"target":"_blank","href":_vm.urlWithUtm},on:{"click":function($event){return _vm.logEvent('Pro Alert Box', {
          action: 'click',
          feature: _vm.options.feature
        })}}},[_vm._v(" Get Pro ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }